module.exports = __webpack_public_path__ + "img/mini_powerpack.9747cbe4.png";